import ajax from '@/utils/ajax';

import { BillingReportRow } from '../types';
import { BulkBillingItemFlagPayload } from '../types/billing_item_flag';
import { ClearIgnoreErrorsPayload } from '../types/billing_item_flag';

export const billingItemFlagRepository = {
  async addFlag({
    host,
    flag
  }: {
    host: string;
    flag: BulkBillingItemFlagPayload;
  }): Promise<BillingReportRow[]> {
    const path = `${host}/api/billing/billing_item_flags/bulk_create/`;
    const payload = {
      type: flag.type,
      reason: flag.reason,
      note: flag.note,
      alerts: flag.alerts || {},
      billing_item_ids: flag.billingItemIds
    };

    const response = await ajax.post<
      typeof payload,
      import('axios').AxiosResponse<BillingReportRow[]>
    >({
      url: path,
      data: payload
    });

    return response.data;
  },
  async clearFlags({
    host,
    payload
  }: {
    host: string;
    payload: ClearIgnoreErrorsPayload;
  }): Promise<void> {
    const { type, billingItemIds, onlyForUser } = payload;
    const path = `${host}/api/billing/billing_item_flags/clear/`;
    await ajax.post({
      url: path,
      data: {
        type,
        billing_item_ids: billingItemIds,
        only_for_user: onlyForUser
      }
    });
  }
};

const BillingItemFlagRepository = (
  host: string
): {
  addFlag: (flag: BulkBillingItemFlagPayload) => Promise<BillingReportRow[]>;
  clearFlags: (payload: ClearIgnoreErrorsPayload) => Promise<void>;
} => {
  return {
    async addFlag(flag: BulkBillingItemFlagPayload): Promise<BillingReportRow[]> {
      return billingItemFlagRepository.addFlag({
        host,
        flag
      });
    },
    async clearFlags(payload: ClearIgnoreErrorsPayload) {
      return billingItemFlagRepository.clearFlags({
        host,
        payload
      });
    }
  };
};

export default BillingItemFlagRepository;
